import { Card, CardProps, GlobalToken } from 'antd';
import { CSSProperties } from 'react';
import styled, { Interpolation } from 'styled-components';

export const HoverableCard = styled(Card)<
  CardProps & {
    theme: GlobalToken;
    styleHover?: Interpolation<CSSProperties>;
    active?: boolean;
  }
>`
  &.ant-card-hoverable {
    border-color: ${({ theme, active }) =>
      active ? theme.colorPrimary : 'transparent'};
    &:hover {
      border-color: ${({ theme }) => theme.colorPrimary};
      box-shadow: none;
      ${({ styleHover }) => styleHover}
    }
  }
`;
